module.exports = __webpack_public_path__ + "img/zyly.c484d338.png";